// IMPORT
import {isScrolled} from './components/utils';
import {scrollBtn} from './components/buttons';
import * as slider from './components/slider';

// LOAD
document.addEventListener('DOMContentLoaded', () => {

    // LINK OBFUSCATION
    var obf = document.querySelectorAll(".obf-link");
    for(var i = 0; i < obf.length; i++){
        obf[i].addEventListener('click', function(){
            var link = atob(this.getAttribute("data-obf"));
            var target = this.getAttribute("data-target");
            if (target == '_blank') {
                window.open(link, '_blank');
            } else {
                window.location.href = link;
            }
        });
    }

    scrollBtn();
    slider.init();
});

// SCROLL
window.addEventListener('load', isScrolled);
window.addEventListener('scroll', isScrolled);
